import {
    StyleSheet
} from "react-native";
import {
    webStyle
} from "ncore-ui-kit";

const stylesheet = StyleSheet.create({
    headerContainer: {
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center"
    },
    footerContainer: {
        justifyContent: "flex-end",
        flexDirection: "row",
        alignItems: "center"
    },
    textInput: {
        textAlignVertical: "top",
        minHeight: 100
    },
    closeButton: {
        ...webStyle({
            cursor: "pointer"
        })
    },
    container: {
        maxWidth: "92%",
        width: 480
    },
    inputContainer: {
        width: "100%"
    }
});
export default stylesheet;
